import React from 'react';
import '../styles/score-card.css';

const CIRCUMFERENCE = 2 * Math.PI * 50;

const clampScore = (value) => {
  if (value == null || Number.isNaN(value)) return null;
  const numeric = Number(value);
  return Math.max(0, Math.min(100, numeric));
};

function ScoreStatCard({
  title,
  infoText,
  value,
  ringValue,
  color = '#00ff41',
  suffix = '',
  showMax = true,
  variant = 'default',
  className = '',
}) {
  const resolvedRing = clampScore(ringValue ?? value);
  const offset = resolvedRing == null ? CIRCUMFERENCE : CIRCUMFERENCE - (resolvedRing / 100) * CIRCUMFERENCE;

  const hasValue = value != null && !Number.isNaN(value);
  const displayValue = hasValue ? `${Math.round(Number(value))}${suffix}` : 'N/A';

  return (
    <article className={`metric-score-card metric-score-card--${variant} ${className}`.trim()}>
      <div className="metric-score-card__gauge">
        <svg viewBox="0 0 120 120" aria-hidden="true">
          <circle cx="60" cy="60" r="50" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="8" />
          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 60 60)"
          />
        </svg>
        <div className="metric-score-card__value-wrap">
          <span className="metric-score-card__value">{displayValue}</span>
          {showMax && <span className="metric-score-card__max">/ 100</span>}
        </div>
      </div>

      <div className="metric-score-card__title-wrap">
        <h3 className="metric-score-card__title">{title}</h3>
        {infoText && (
          <span className="metric-score-card__info">
            <button
              type="button"
              className="metric-score-card__info-button"
              aria-label={`${title} information`}
            >
              ?
            </button>
            <span className="metric-score-card__tooltip" role="tooltip">
              {infoText}
            </span>
          </span>
        )}
      </div>
    </article>
  );
}

export default ScoreStatCard;
